import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { LoaderCircle } from "lucide-react";
import logo from "../assets/logo.jpg";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("تم تسجيل الدخول بنجاح");
      navigate(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" dir="rtl" style={{ backgroundColor: "#2a3b19" }}>
      <form onSubmit={submit} className="relative w-full max-w-md">
        <div className="flex flex-col items-center mb-10">
          <img src={logo} alt="modarreb" className="h-24 w-64 object-cover rounded-2xl mb-4" />
          <p className="text-white/70 text-sm mt-1">نظام إدارة الفريق للمدربين</p>
        </div>

        <label className="block text-sm font-medium text-white mb-1">البريد الإلكتروني</label>
        <input
          data-testid="login-email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full mb-4 px-4 py-3 rounded-xl bg-white/5 border border-white/40 text-white placeholder-white/40 focus:border-white outline-none transition-colors"
          placeholder="example@email.com"
        />

        <label className="block text-sm font-medium text-white mb-1">كلمة المرور</label>
        <input
          data-testid="login-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full mb-6 px-4 py-3 rounded-xl bg-white/5 border border-white/40 text-white placeholder-white/40 focus:border-white outline-none transition-colors"
          placeholder="••••••••"
        />

        {error && (
          <div data-testid="login-error" className="mb-4 text-sm text-red-200 bg-red-500/20 border border-red-400/40 rounded-xl px-4 py-3">
            {error}
          </div>
        )}

        <button
          data-testid="login-submit"
          type="submit"
          disabled={loading}
          className="w-full py-3 rounded-xl bg-white hover:bg-white/90 text-[#2a3b19] font-bold transition-colors flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading && <LoaderCircle className="animate-spin" size={18} />}
          تسجيل الدخول
        </button>
        <p className="text-center text-xs text-white/50 mt-6">
          الحسابات تُنشأ من قبل المدير فقط
        </p>
      </form>
    </div>
  );
}
